'use strict';

var lane = {
  xs: 20,
  // tmpgraphlane0.width
  ys: 20,
  // tmpgraphlane0.height
  xg: 120,
  // tmpgraphlane0.x
  // yg     : 0,     // head gap
  yh0: 0,
  // head gap title
  yh1: 0,
  // head gap
  yf0: 0,
  // foot gap
  yf1: 0,
  // foot gap
  y0: 5,
  // tmpgraphlane0.y
  yo: 30,
  // tmpgraphlane1.y - y0;
  tgo: -10,
  // tmptextlane0.x - xg;
  ym: 15,
  // tmptextlane0.y - y0
  xlabel: 6,
  // tmptextlabel.x - xg;
  xmax: 1,
  scale: 1,
  head: {},
  foot: {}
};
module.exports = lane;